import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import UserListTableHeaderComponent from "../component/UserListTableHeaderComponent";
import { ConfigProvider, notification, Pagination, message } from "antd";
import UserItemComponent from "../component/UserItemComponent";
import AddUserModal from "../component/modals/AddUserModal";
import EditUserModal from "../component/modals/EditUserModal";
import ConfirmationModal from "../component/modals/ConfirmationModal";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import moment from "moment";
import CustomLoader from "../component/menu/CustomLoader";
import { getParentRestaurantDropdown } from "../services/user-service";

function Users() {
  const [api, contextHolder] = notification.useNotification();
  const { isLoggedIn, user, branches, restaurantId, setNetworkCall, showNotification } =
    useUserStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [changeBranchModal, setChangeBranchModal] = useState(false);
  const [viewStaffModal, setViewStaffModal] = useState(false);
  const [action, setAction] = useState();
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [selectedItem, setSelectedItem] = useState({});
  const [stuffs, setStuffs] = useState([]);
  const [userlist, setUserList] = useState([]);
  const [parentRestaurantList, setParentRestaurantList] = useState([]);
  const [isLoadedParentRestaurants, setIsLoadedParentRestaurants] =
    useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState({
    searchKey: "",
    parentRestaurantId: "",
    branchId: "",
    role: "",
    status: "",
    sortBy: "newest",
    page: 1,
    perPage: 500,
  });

  const [parentRestaurantId, setParentRestaurantId] = useState("");

  const branchOptions = branches.map((branch) => ({
    value: branch.slug, // Unique identifier
    label: `${branch.name}-${branch.branch}`, // Combine restaurant name and branch
  }));

  const onClickAddButton = (value) => {
    setIsModalOpen(value);
  };

  const openNotification = (
    type,
    message,
    description,
    placement = "topRight"
  ) => {
    api[type]({
      message,
      description,
      placement,
    });
  };

  const onClickSaveButtonInModal = async (response) => {
    // fetchStuffList();
    getUserList();

    setIsModalOpen(false);
  };

  const onEditClickSaveButtonInModal = async (response) => {
    // fetchStuffList();
    getUserList();

    setIsEditModalOpen(false);
  };

  const onClickViewStaffModal = () => {
    setViewStaffModal(false);
  };

  const onClickCancelButtonInModal = () => {
    setIsModalOpen(false);
  };

  const onEditClickCancelButtonInModal = () => {
    setIsEditModalOpen(false);
  };

  const onSelectStaff = (val, action) => {
    switch (action) {
      case constants.STAFF.CHANGE: {
        setSelectedItem(val);
        // setViewStaffModal(true)
        setChangeBranchModal(true);
        break;
      }
      case constants.STAFF.VIEW: {
        setSelectedItem(val);
        setViewStaffModal(true);
        break;
      }
      case constants.STAFF.EDIT: {
        setSelectedItem(val);
        setIsEditModalOpen(true);
        break;
      }
      case constants.STAFF.ON: {
        setConfirmationMessage(
          `Are you sure want to on <b>${val.name}</b> staff duty?`
        );
        setSelectedItem(val);
        setAction(constants.STAFF.ON);
        setIsConfirmModalOpen(true);
        break;
      }
      case constants.STAFF.OFF: {
        setConfirmationMessage(
          `Are you sure want to off <b>${val.name}</b> staff duty?`
        );
        setSelectedItem(val);
        setAction(constants.STAFF.OFF);
        setIsConfirmModalOpen(true);
        break;
      }
      case constants.STAFF.DELETE: {
        setConfirmationMessage(
          `Are you sure want to delete <b>${val.role}</b> <b>${val.name}</b> from all restaurants?`
        );
        setSelectedItem(val);
        setAction(constants.STAFF.DELETE);
        setIsConfirmModalOpen(true);
        break;
      }
    }
  };
  // Main function to handle confirmation
  const onConfirm = (record, action) => {
    if (action === constants.STAFF.DELETE) {
      handleDelete(record);
    } else {
      stuffStatusChange(record, action);
    }
    setIsConfirmModalOpen(false);
  };

  const handleDelete = async (record) => {
    try {
      const params = {
        id: record.id,
        parentRestaurantId: record.parentRestaurantInfo.id,
        branchId: record.branchInfo.id,
      }; // Prepare the params with the record ID
      
      // return
      const response = await ApiService.DELETE_RESTAURANT_USER(
        params,
        user.token.token
      ); // Call the DELETE API

      if (response.message === "Success") {
        // Optional: Display success message
        message.success("User deleted successfully.");
        // Update UI or refresh data if needed
        getUserList();
      } else {
        // Optional: Handle unsuccessful delete response
        message.error(response.message || "Failed to delete user.");
      }
    } catch (error) {
      // Handle error
      console.error("Error deleting user:", error);
      message.error("An error occurred while deleting the user.");
    }
  };

  const stuffStatusChange = async (record, action) => {
    const status = action !== constants.STAFF.DELETE ? 0 : 1;

    const response = await ApiService.STAFF_STATUS_CHANGE(
      {
        restaurantId,
        staffId: record._id,
        retire: status,
      },
      user.token.token
    );

    if (response.code !== 200) {
      return;
    }

    fetchStuffList();
  };

  const onNotConfirm = () => {
    setIsConfirmModalOpen(false);
  };

  const fetchStuffList = async () => {
    await ApiService.FILTER_STUFF_LIST(filter, user.token.token).then((res) => {
      if (!res || (res && res.code !== 200)) {
        return;
      }

      let newStuffs = [];
      let positions = [];

      res.payload.staffs.map((stuff) => {
        if (!res || (res && res.code !== 200)) {
          return;
        }

        positions = [];

        stuff.restaurants.map((pos) => positions.push(pos.position));

        newStuffs.push({
          _id: stuff._id,
          order_id: 1,
          name: stuff.name,
          position: positions.join(", "),
          contact: stuff.phone,
          gender: stuff.gender,
          econtact: `${stuff.emergencyContactNumber} (${stuff.emergencyContactName})`,
          econ: stuff.emergencyContactNumber,
          econ_name: stuff.emergencyContactName,
          address: stuff.address,
          day: "Sat - Thu",
          time: "14:00 ~ 23:00",
          dob: moment(stuff.dob).format("YYYY-MM-DD"),
          restaurants: stuff.restaurants,
          // status: stuff.restaurants[0].status.toLowerCase(),
          status: stuff.restaurants.every(
            (restaurant) => restaurant.status === "Off"
          )
            ? "off"
            : "on",
        });
      });

      setStuffs(newStuffs);
      setTotal(res.payload.pagination.total);
    });
  };

  const getUserList = async () => {
    try {
    setNetworkCall(true)

    const res = await ApiService.GET_USER_LIST(filter, user.token.token);
    setNetworkCall(false);

    if (res.status === "ok") {
      setUserList(res.payload.records);
    }
    } catch (error) {
      console.error('Failed to load users. Error:', error);
      showNotification("Failed to load users.");
    } finally {
      setNetworkCall(false)
    }
  };
  
  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const onChangeSearchKey = (value) => {
    setFilter({
      ...filter,
      searchKey: value,
    });
  };

  const onRestaurantChange = (value) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      parentRestaurantId: value ?? "", // Convert null to empty string
      branchId: value ? prevFilter.branchId : "", // Clear branchId if restaurant is cleared
    }));
  };

  const onBranchChange = (value) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      branchId: value ?? "", // Convert null to empty string
    }));
  };

  const onChangeRole = (value) => {
    setFilter({
      ...filter,
      role: value,
    });
  };

  const onChangeSortBy = (value) => {
    setFilter({
      ...filter,
      sortBy: value,
    });
  };

  useEffect(() => {
    getUserList();
  }, [filter]);

  useEffect(() => {
    (async () => {
      setIsLoadedParentRestaurants(true);
      const records = await getParentRestaurantDropdown({}, user.token.token);

      setParentRestaurantList(records);
      setIsLoadedParentRestaurants(false);
    })();
  }, []);
  return (
    <div className="flex flex-col">
      <Header title={`McDonalds Food Chain`} menu={constants.SUPER_MENU.USER} currentMenuKey={'T_52_S_52'}/>
      {contextHolder}
      <CustomLoader />
      <div className="flex flex-row bg-prewhite">
        <SideMenu
          title={`McDonalds Food Chain`}
          menu={constants.SUPER_MENU.USER}
        />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <UserListTableHeaderComponent
              openModal={setIsModalOpen}
              onChangeSearchKeyWord={onChangeSearchKey}
              onRestaurantChange={onRestaurantChange}
              onBranchChange={onBranchChange}
              onChangeType={onChangeRole}
              onChangeSortBy={onChangeSortBy}
            />
            
            <div className="flex flex-col">
              {userlist.map((item, index) => {
                return (
                  <div key={index}>
                    <UserItemComponent record={item} callback={onSelectStaff} />
                  </div>
                );
              })}
            </div>
            {userlist.length === 0 && (
              <div className="text-red-600 mt-[200px] mb-[100px] text-center">Data not found.</div>
            )}
            <div className="flex flex-row justify-start font-uregular">
              <ConfigProvider
                theme={{
                  components: {
                    Pagination: {
                      itemActiveBg: "#FFD700",
                      fontFamily: "ubold",
                      colorPrimaryBorder: "#FFD700",
                      colorPrimary: "#111111",
                      colorPrimaryHover: "#111111",
                      itemInputBg: "#111111",
                      itemBg: "#E5E4E9",
                    },
                  },
                }}
              >
                <Pagination
                  total={total}
                  showTotal={(total) => `Total ${total} items`}
                  defaultPageSize={perPage}
                  defaultCurrent={currentPage}
                  current={currentPage}
                  onChange={onPageChange}
                  showSizeChanger={false}
                />
              </ConfigProvider>
            </div>
          </div>
          {/* <ChangeStaffBranchModal
            openModal={changeBranchModal}
            records={{
              brancheOptions: branchOptions,
              selectedItem: selectedItem,
              onFinish: handleBranchChangeFinish,
              onCancel: handleBranchChangeCancel,
            }}
          /> */}

          <AddUserModal
            openModal={isModalOpen}
            params={{
              onFinish: onClickSaveButtonInModal,
              onCancel: onClickCancelButtonInModal,
              seletedItem: selectedItem,
              allRestaurantList: parentRestaurantList,
            }}
          />
          <EditUserModal
            openModal={isEditModalOpen}
            params={{
              onFinish: onEditClickSaveButtonInModal,
              onCancel: onEditClickCancelButtonInModal,
              allRestaurantList: parentRestaurantList,
              selectedItem: selectedItem,
            }}
          />
          {/* <ViewStaffModal
            openModal={viewStaffModal}
            records={{
              onFinish: onClickViewStaffModal,
              onCancel: onClickViewStaffModal,
              param: selectedItem,
            }}
          /> */}
          <ConfirmationModal
            openModal={isConfirmModalOpen}
            records={{
              onFinish: onConfirm,
              onCancel: onNotConfirm,
              message: confirmationMessage,
              param: selectedItem,
              action: action,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Users;
